import { AuthProvider as OdicAuthProvider } from 'react-oidc-context';

import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

import { PropsWithChildren } from 'react';

import { storage as credentialStorage } from 'common/auth/credential';
import { env } from 'utils/env';

const oidcConfig: UserManagerSettings = {
  authority: `${env.CLASSTING_OIDC_URL}/oidc`,
  client_id: env.CLASSTING_OIDC_CLIENT_ID ?? '',
  redirect_uri: `${window.location.origin}/authentication`,
  silent_redirect_uri: `${window.location.origin}/authentication`,
  response_type: 'code',
  scope: 'openid email profile',
  userStore: new WebStorageStateStore({
    store: credentialStorage,
  }),
};

const AuthProvider = (props: PropsWithChildren<{}>) => {
  return <OdicAuthProvider {...oidcConfig} {...props} />;
};

export default AuthProvider;
